import { Navigate, Outlet } from "react-router-dom";

/**
 * GuestRoute
 * - Not logged in (no token) → show the page (e.g. /login)
 * - Already logged in        → redirect to /expertview
 */
export default function GuestRoute() {
  const token = localStorage.getItem("token");
  return token ? <Navigate to="/expertview" replace /> : <Outlet />;
}
